import { repositories } from "@/core";
import { minLength, required, sameAs } from "vuelidate/lib/validators";
export default {
  name: "AddAdmins",
  mounted() {},
  data() {
    return {
      id: this.$route.params.id,
      errorMessage: "",
      submitting: false,
      filters: {
        page: 1,
        search: "",
      },
      form: {
        old_password: "",
        password: "",
        passwordConfirmation: "",
      },
    };
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8),
      },
      old_password: {
        required,
        minLength: minLength(8),
      },
      passwordConfirmation: {
        required,
        sameAs: sameAs("password"),
        minLength: minLength(8),
      },
    },
  },
  methods: {
    async submit() {
      try {
        this.submitting = true;
        this.errorMessage = "";
        const f = { ...this.form };
        delete f.passwordConfirmation;
        const res = await repositories.userService.update(this.id, f);
        this.$eventBus.$emit("showToast", {
          title: "Senha alterada",
          msg: `Senha do Admin alterada com sucesso`,
        });
        this.$router.back();
      } catch (e) {
        this.errorMessage = e.message;
      } finally {
        this.submitting = false;
      }
    },
  },
};
